import {createSlice} from '@reduxjs/toolkit';

export const loaderSlice = createSlice({
    name: 'loader',
    initialState: {
        status: false,
        defaultCase: undefined,
    },
    reducers: {
        loadOn: (state) => {
            state.status = true;
            state.defaultCase = true;
        },
        loadOff: (state, props) => {
            if(!state.status) {
                return
            }
            state.status = false;
        },
        loadOnAccordeon: (state) => {
            state.status = true;
            state.defaultCase = false;
        },
    },
});

export const filterLoaderSlice = createSlice({
    name: 'filterLoader',
    initialState: {
        status: false,
    },
    reducers: {
        loadOnFilter: (state) => {
            state.status = true;
        },
        loadOffFilter: (state) => {
            state.status = false;
        },
    },
});

export const {loadOn, loadOff, loadOnAccordeon} = loaderSlice.actions;
export const {loadOnFilter, loadOffFilter} = filterLoaderSlice.actions;

export const selectLoadingbarStatus = (state) => state.loader;
export const selectFilterLoadingbarStatus = (state) => state.filterLoader;
